var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 11,
    viewBox: "0 0 21 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.5l5 5 1.196-1.196L3.24 6.346h17.58V4.654H3.238l2.957-2.958L5 .5l-5 5z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "media/icons/back-38d6aa0a.svg";
export { SvgBack as ReactComponent };